var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38184 5.20956C1.40081 4.9709 1.50815 4.74821 1.68247 4.58583C1.85679 4.42346 2.0853 4.33332 2.3225 4.33337H8.01083C8.24803 4.33332 8.47654 4.42346 8.65086 4.58583C8.82518 4.74821 8.93252 4.9709 8.9515 5.20956L9.33031 9.97147C9.34073 10.1025 9.32416 10.2343 9.28164 10.3586C9.23912 10.4828 9.17157 10.5969 9.08326 10.6935C8.99494 10.7901 8.88776 10.8672 8.76847 10.92C8.64918 10.9727 8.52036 11 8.39012 11H1.94322C1.81298 11 1.68416 10.9727 1.56487 10.92C1.44557 10.8672 1.33839 10.7901 1.25008 10.6935C1.16176 10.5969 1.09421 10.4828 1.05169 10.3586C1.00918 10.2343 0.992605 10.1025 1.00302 9.97147L1.38184 5.20956V5.20956Z",
    stroke: "#191919",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 5.16667V2.85185C6.83333 2.36071 6.65774 1.88968 6.34518 1.54239C6.03262 1.19511 5.60869 1 5.16667 1C4.72464 1 4.30072 1.19511 3.98816 1.54239C3.67559 1.88968 3.5 2.36071 3.5 2.85185V5.16667",
    stroke: "#191919",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeShipping);
export default __webpack_public_path__ + "static/media/freeShipping.0d07f3e818bf5adc07121f0b776d9a27.svg";
export { ForwardRef as ReactComponent };